import { z } from 'zod'

export const zGetInsuranceCampaignsIssuesStatsForAdminEndpointInput = z
  .object({
    fromDate: z.coerce.date(),
    toDate: z.coerce.date(),
  })
  .superRefine((data, ctx) => {
    if (data.fromDate > data.toDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Дата начала должна быть раньше даты конца',
        path: ['fromDate'],
      })
    }
    const diffInMs = data.toDate.getTime() - data.fromDate.getTime()
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24)
    if (diffInDays > 30) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Период не может быть больше 30 дней',
        path: ['toDate'],
      })
    }
  })
